<template>
  <div class="d-flex">
    <v-autocomplete
        :menu-props="{ bottom: true, offsetY: true }"
        class="rounded-lg"
        :items="items"
        v-model="item"
        :label="label"
        item-text="name"
        item-value="value"
        :disabled="disabled"
        :multiple="multiple"
        :placeholder="placeholder"
        :return-object="false"
    ></v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'CurrencySelect',
  props: {
    value: {},
    label: {
      default: null
    },
    placeholder: {
      default: null
    },
    disabled: {
      default: false
    },
    multiple: {
      default: false
    }
  },
  data() {
    return {
      items: [],
      item: null
    };
  },
  computed: {
  },
  created() {
    this.getItems();
  },
  mounted(){
    this.setItem();
  },
  methods: {
    getItems() {
      this.request({
        url: this.endpoint(`main/currency`),
        method: "get",
        success: data => {
          this.items = []
          for (let currency of data) {
            this.items.push({
              'name': currency.name,
              'value': currency.id,
            })
          }
        }
      })
    },

    setItem() {
      if (this.value != this.item) this.item = this.value;
    }
  },
  watch: {
    value() {
      this.setItem();
    },
    item() {
      this.$emit("input", this.item);
    }
  }
};
</script>


<style lang="scss" scoped></style>